(() => {

    const handleClick = () => {
        const pwds = document.querySelectorAll(".pwd");

        for (let pwd of pwds) {
            const type = pwd.getAttribute("type");
            const newType = type === "text" ? "password" : "text";
            pwd.setAttribute("type", newType);
        }
    };

    const init = () => {
        const reveals = document.querySelectorAll(".reveal");

        for (let reveal of reveals) {
            reveal.addEventListener("click", handleClick);
        }
    };

    document.addEventListener("DOMContentLoaded", init);
})();